export enum ActionStepType {
  Other,
  Save,
  Rebalance,
  PaymentStrategy,
  CoverPrincipalLife,
  CoverSpouseLife,
  CoverPrincipalDisability,
  CoverSpouseDisability,
  CoverPrincipalLtc,
  CoverSpouseLtc,
  Suggestion,
  AdditionalTips,
  InsuranceNoteRecommendation,
  ReviewSpendingActionStep,
  CoverPrincipalLifeV2,
  CoverSpouseLifeV2,
  RefinanceActionStep,
  EstatePlanningDocumentUpdateActionStep,
  EstatePlanningBeneficiaryUpdateActionStep,
  RothConversionActionStep,
}

export interface ActionStepTypeOptionDTO {
  label: string;
  value: ActionStepType;
}
